// extracted by mini-css-extract-plugin
export var pillWrapper = "_op-0";
export var showOverflow = "_op-1";